/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMergeRows = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 13v2l-3-.001v5h16v-5L17 15v-2h5v9H2v-9zm6-4v2h2v2h-2.001L13 15h-2v-2.001L9 13v-2l2-.001V9zm9-7v9h-5V9l3-.001v-5H4v5L7 9v2H2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMergeRows as MergeRows };
